import { useEffect, useState } from 'react'

/**
 * Hook for detecting if the user device is mobile
 */
export function useDetectMobile(breakpoint) {
  const [isMobile, setIsMobile] = useState(false)

  const detectMobile = () => {
    window.innerWidth < breakpoint ? setIsMobile(true) : setIsMobile(false)
  }

  useEffect(() => {
    // on load
    detectMobile()
    // on resize
    window.addEventListener('resize', detectMobile)
  }, [])

  useEffect(() => {
    return () => {
      window.removeEventListener('resize', detectMobile)
    }
  }, [])

  return [isMobile]
}
